import { depthLabel } from '@/common/app/modules/media/queryFanout'
import { ConversationFlowItem } from '@/common/model/media/queryFanout'
import { zeroPadding } from '@/common/util/number'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Heading from '@/components/view/atoms/heading/Heading'
import SummaryHeading from '@/components/view/atoms/heading/SummaryHeading'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  flow: ConversationFlowItem[]
}

// 会話深度1段階分のカード
const FlowCard = ({ item }: { item: ConversationFlowItem }) => (
  <Area>
    {/* 深度・質問・言及有無 */}
    <Heading
      rightNode={
        <Badge
          size={10}
          badgeType={item.own_brand_mentioned ? BadgeType.SUCCESS : BadgeType.CRITICAL}
          fixed
        >
          {item.own_brand_mentioned
            ? item.own_brand_position
              ? `言及あり（${item.own_brand_position}位）`
              : '言及あり'
            : '言及なし'}
        </Badge>
      }
    >
      <ItemAlign gapX={8} align='baseline'>
        <Badge size={12} badgeType={BadgeType.SQUARE_PRIMARY} fixed>
          {depthLabel(item.depth)}
        </Badge>
        {item.query}
      </ItemAlign>
    </Heading>
    <AreaContent>
      {item.response_summary && (
        <Text size={12} color={TextColor.SECONDARY} lineHeight={150}>
          {item.response_summary}
        </Text>
      )}

      {/* 回答内で言及されたブランド */}
      {(item.all_brands_mentioned?.length ?? 0) > 0 && (
        <div className='flex flex-wrap gap-1.5'>
          {item.all_brands_mentioned?.map((brand, i) => (
            <Badge key={i} size={12} badgeType={BadgeType.KEYWORD}>
              {brand}
            </Badge>
          ))}
        </div>
      )}

      {/* AIが生成したフォローアップ候補（先頭が次の深度の質問になる） */}
      {(item.followup_questions?.length ?? 0) > 0 && (
        <div className='flex flex-col gap-1.5'>
          <ItemAlign gapX={8} align='baseline'>
            <Text size={12} weight='bold'>
              次のフォローアップ候補
            </Text>
            <Text size={10} color={TextColor.SECONDARY}>
              AIが3〜5件生成し、先頭を採用
            </Text>
          </ItemAlign>
          {item.followup_questions?.map((question, i) => (
            <div key={i} className='border-primary flex items-stretch rounded-lg border'>
              <div className='border-primary flex w-10 shrink-0 items-center justify-center border-r px-2 py-1.5'>
                <Badge size={12} badgeType={BadgeType.SQUARE_SECONDARY} fixed>
                  {zeroPadding(i + 1, 2)}
                </Badge>
              </div>
              <div className='flex-1 px-3 py-1.5'>
                <Text size={14} lineHeight={150}>
                  {question}
                </Text>
              </div>
            </div>
          ))}
        </div>
      )}
    </AreaContent>
  </Area>
)

// 会話フロー（メイン質問からフォローアップまでの言及推移）
const QueryFanoutConversationFlow = ({ flow }: Props) => (
  <>
    <SummaryHeading subText='メイン質問からフォローアップまでの自社ブランド言及推移'>
      会話フロー
    </SummaryHeading>
    <div className='flex flex-col gap-3'>
      {flow.map((item, i) => (
        <FlowCard key={i} item={item} />
      ))}
    </div>
  </>
)

export default QueryFanoutConversationFlow
